import React from "react";
import FilterHeader from "../../Shared/FilterHeader/FilterHeader";
import Paginate from "../../layout/Paginate";
import SoldItemsCard from "./SoldItemsCard";

const SoldItems = ({ title, products }) => {
  return (
    <div className="grow">
      <FilterHeader title={title} />
      <Paginate
        itemsPerPage={5}
        data={products}
        element={(props) => <SoldItemsCard {...props} />}
        containerClassName="flex flex-col gap-4 mt-8"
      />
    </div>
  );
};

export default SoldItems;
